module.exports = __webpack_public_path__ + "png/quick-registration-coin-5.png?85d47bb17b8049f0ca613b085cc30ee9";